<div
  class="display-flex flex-direction-column justify-content-center align-items-center mt-4@r ph-12 pl-0@tablet pr-0@tablet max-width-360@tablet"
>
  <sb-profile-photo
    [photoUrl]="profile().profile_photo_url"
    [route]="`/next/profile/${profile().browse_id}`"
    [showFavoriteBadge]="profile().favorited"
    [size]="'xl'"
  />
  <div class="mt-2@r mb-1@r t-6@r font-weight-500">
    {{ profile().username }}
    @if (profile().verified) {
      <sb-icon class="color-verified" [name]="'verify'" [secondaryColor]="'white'" [size]="'10'" />
    }
  </div>
  @if (conversationStore.isSuggestedProfile() && siteStore.features().message_suggested_profiles) {
    <div class="color-ash mb-1@r">{{ profile().age }} • {{ profile().display_location }}</div>
    <div class="color-iron t-9@r text-align-center max-width-350@tablet mb-3@r">
      {{ profile().tagline }}
    </div>
    <button
      sbButton
      [queryParams]="{ source: 'messages-page-suggestions' }"
      [routerLink]="['/next/profile', profile().browse_id]"
      [variant]="'fill-jet'"
    >
      View Profile
    </button>
  } @else {
    <div class="color-charcoal mb-6@r t-7@r text-align-center">
      You haven’t spoken to {{ profile().username }} in a while
    </div>
    <div class="color-iron t-9@r text-align-center max-width-350@tablet">
      For your privacy older messages have been erased from this conversation.
    </div>
  }
</div>
